<template>
	<div>
		<modaluser v-model="dialog" :propAdd='paramProp' :val = 'val' @getData="getData" :filter="{limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}"/>
		<modalpassword type="supplier" ref="modalPassword" :selectedUser="selectedUser" :filter="{limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}"/>
		<modalconfirm ref="modalconfirmUser" @action="deleteData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Pengguna Supplier</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn dark depressed class="primary" @click.stop="() => {dialog=true; paramProp='tambah'; val = {};}">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Pengguna</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn class="primary" text dark @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="userResults" :search="search" hide-default-footer :options.sync="option" :server-items-length="userPagination.total_data">
				<template v-slot:item.user_supplier_name="{ item }">
					<div class="d-flex">
						<v-avatar color="indigo" size="36">
							<img class="avatar" :src="item.user_supplier_image ? item.user_supplier_image : '/assets/user/profile-pict-menolak-big.png'">
						</v-avatar>
						<div class="pl-2 my-auto">{{ item.user_supplier_name }}</div>
					</div>
				</template>
				<template v-slot:item.supplier_name="{ item }">
					<div class="text-capitalize">{{ item.supplier_name }}</div>
				</template>
				<template v-slot:item.contact="{ item }">
					<div class="pt-2">{{ item.user_supplier_mobilephone }}</div>
					<div class="pb-2">{{ item.user_supplier_email }}</div>
				</template>
				<template v-slot:item.user_supplier_is_active="{ item }">
					<v-switch v-model="item.user_supplier_is_active" @change="editStatus(item)"></v-switch>
				</template>
				<template v-slot:item.user_supplier_username="{ item }">
					<div class="pt-2">{{ item.user_supplier_username }}</div>
					<div class="pb-2 text-capitalize">{{ item.user_supplier_type }}</div>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on" @click.stop="() => {val= item; dialog=true; paramProp='edit'}">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="mr-1" fab dark x-small depressed color="amber darken-4" v-bind="attrs" v-on="on" @click.stop="() => { $refs.modalPassword.show(); selectedUser = item.user_supplier_id}">
								<v-icon dark>mdi-key-variant</v-icon>
							</v-btn>
						</template>
						<span>Ubah Kata Sandi</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="showConfirmation(item.user_supplier_id, item.user_supplier_name)">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!userPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="userPagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" @input="changePage" :length="userPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import modaluser from '@/views/MLwarehouse/user/ModalUserSupplier'
import modalpassword from '@/views/MLwarehouse/user/ModalPassword'
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modaluser, modalpassword
	},
	data() {
		return {
			theactive:[],
			selectedUser: '',
			sortBy: '',
			sortDir: 'ASC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			paramProp: '',
			propDelete: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Nama', align: 'start', value: 'user_supplier_name'},
			{ text: 'Supplier', align: 'start', value: 'supplier_name'},
			{ text: 'Kontak', value: 'contact', sortable: false},
			{ text: 'Username', value: 'user_supplier_username' },
			{ text: 'Aktif', value: 'user_supplier_is_active'},
			{ text: 'Aksi', value: 'action', sortable: false, },
			],
			filterData: [{
				type: 'text',
				label: 'Nama',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'user_supplier_name'
				}
			}, {
				type: 'text',
				label: 'No Hp',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'user_supplier_mobilephone'
				}
			}, {
				type: 'text',
				label: 'Email',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'user_supplier_email'
				}
			}, {
				type: 'text',
				label: 'Username',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'user_supplier_username'
				}
			}, {
				type: 'selection',
				label: 'Tipe',
				item: ['superuser', 'administrator'],
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'user_supplier_type'
				}
			}, {
				type: 'selection',
				label: 'Supplier',
				itemValue: 'supplier_id',
				itemText: 'supplier_name',
				item: [],
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'user_supplier_supplier_id'
				}
			},
			],
			params: [],
			paramStatus : {
				id : '',
				status : ''
			}
		}
	},
	props: {
	},
	computed: {
		...mapState('supplierUser', ['userResults', 'userPagination', 'OptionSupplier']),
	},
	methods: {
		...mapActions('supplierUser', ['getDataUser', 'getTypeOption', 'getSupplierOption', 'status', 'delete']),
		...mapMutations('supplierUser', ['clearDataUser']),
		...mapMutations(['setOverlay', 'setFilter']),

		getData(){
			this.getDataUser(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		editStatus(stat){
			this.paramStatus.id = stat.user_supplier_id
			if (stat.user_supplier_is_active== false) {
				this.paramStatus.status = 'inactive'
			} else {
				this.paramStatus.status = 'active'
			}
			this.status(this.paramStatus).then(() => {
				this.getData()
			})
		},
		changePage (page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.params = []
			this.getData()
		},
		showConfirmation(id, name){
			this.propDelete = id
			let msg = `Yakin ingin menghapus ${name}`
			this.$refs.modalconfirmUser.setMessage(msg)
			this.$refs.modalconfirmUser.showConfirm()
		},
		async deleteData() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmUser.hideConfirm()
			await this.delete(this.propDelete).then( () => {
				this.page = 1
				this.getData()
			})
			await this.setOverlay(false)
		},
	},
	async created() {
		let indexSupplier = await this.filterData.findIndex(el => el.label == 'Supplier')
		this.filterData[indexSupplier].item = await this.getSupplierOption()
		await this.setFilter(this.filterData)

		await this.getData()
		this.$store.dispatch('setPageTitle', `User Supplier`);
	},
	beforeDestroy(){
		this.clearDataUser()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>